import { Injectable, signal } from '@angular/core';

// Guarda el estado del código de verificación mientras se navega de /login a
// /login/verification (y, luego, a /login/complete-profile si el correo es nuevo). Se
// reinicia al confirmar el registro o al volver al login.
@Injectable({ providedIn: 'root' })
export class VerificacionService {
  private readonly correoSignal = signal<string | null>(null);
  readonly correo = this.correoSignal.asReadonly();

  private readonly verificationRequestIdSignal = signal<string | null>(null);
  readonly verificationRequestId = this.verificationRequestIdSignal.asReadonly();

  private readonly terminosAceptadosSignal = signal(false);
  readonly terminosAceptados = this.terminosAceptadosSignal.asReadonly();

  iniciar(correo: string, verificationRequestId: string): void {
    this.correoSignal.set(correo);
    this.verificationRequestIdSignal.set(verificationRequestId);
    this.terminosAceptadosSignal.set(false);
  }

  // El reenvío (POST /email-verifications/resend) devuelve el mismo verificationRequestId,
  // pero un código nuevo lo invalida igual si el usuario alcanzó a solicitar otro desde /login.
  actualizarVerificationRequestId(verificationRequestId: string): void {
    this.verificationRequestIdSignal.set(verificationRequestId);
  }

  guardarTerminos(aceptados: boolean): void {
    this.terminosAceptadosSignal.set(aceptados);
  }

  reiniciar(): void {
    this.correoSignal.set(null);
    this.verificationRequestIdSignal.set(null);
    this.terminosAceptadosSignal.set(false);
  }
}
